import { ChangeEvent } from "react";
import { MessageFormStateInterface } from "../../../interfaces/MessageInterface";
import InputIcon from "../../atoms/InputIcon";

export type FileType = "jpg" | "gif" | "png" | "pdf";

const mimeTypes: Record<FileType, string> = {
  jpg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  pdf: "application/pdf",
};

interface AttachmentIconProps {
  allowedFileTypes: FileType[];
  formState?: MessageFormStateInterface;
  // 選んだファイルはプレビュー画面を通してから添付する
  onSelectFile: (file: File) => void;
}

export const AttachmentIcon = ({
  allowedFileTypes,
  formState,
  onSelectFile,
}: AttachmentIconProps) => {
  const handleChangeFileAttachment = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.currentTarget.files?.[0];
    if (!file) {
      return;
    }

    onSelectFile(file);
  };

  return (
    <InputIcon
      iconName="icon-picture-img"
      inputAttributes={{
        accept: allowedFileTypes.map((t) => mimeTypes[t]).join(","),
        id: "message_image",
        type: "file",
      }}
      tooltipLabel={`ファイルの添付( ${allowedFileTypes
        .map((t) => t)
        .join(",")} )`}
      onChange={handleChangeFileAttachment}
      disabled={!!formState?.values.content || formState?.submitting}
    />
  );
};
